import { FC, useEffect, useRef } from 'react';

import { NeatGradient } from '@firecms/neat'; // Correct import

import { NEAT_BACKGROUND_CONFIGS } from '../webinarLobby.constants';

import styles from './WebinarLobbyBackground.module.scss';

interface WebinarLobbyBackgroundProps {
  children?: React.ReactNode;
}

const WebinarLobbyBackground: FC<WebinarLobbyBackgroundProps> = ({ children }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const neatInstance = useRef<NeatGradient | null>(null);

  useEffect(() => {
    if (canvasRef.current) {
      neatInstance.current = new NeatGradient({
        ...NEAT_BACKGROUND_CONFIGS,
        ref: canvasRef.current,
        
      });
    }

    return () => {
      if (neatInstance.current) {
        neatInstance.current.destroy();
        neatInstance.current = null;
      }
    };
  }, []);

  return (
    <div className={styles.lobbyBgWrapper}>
      <canvas ref={canvasRef} className={styles.lobbyBgCanvas}></canvas>
      <div className={styles.lobbyBgContent}>{children}</div>
    </div>
  );
};

export default WebinarLobbyBackground;
